<template>
  <div class="thermog page-wrapper">
    <el-image
      class="banner"
      style="width: 100%;"
      :src="require('../../assets/tg_banner.png')"
      fit="scale-down">
    </el-image>
    <div class="container">
      <div class="row">
        <h2 class="section1">
          产品细节
        </h2>
        <el-row class="section2" :gutter="40">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/tg_photo1.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <div class="text">
              <h3>无需充电、即插即用</h3>
              <p>随手测测温计，采用TYPE-C接口连接手机工作，终 身无需充电，即插即用</p>
            </div>
          </el-col>
        </el-row>
        <el-row class="section3" :gutter="40">
          <el-col :span="12" :xs="{span: 24}" class="text">
            <div class="text">
              <h3>测量更精准，更快速</h3>
              <p>随手测测温计，内置美国原厂封装BM43THA80C 高精度数字探头，能快速精准的测试温度</p>
            </div>
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/tg_photo2.png" alt="">
          </el-col>
        </el-row>
        <el-row class="section4" :gutter="40">
          <el-col :span="12"  :xs="{span: 24}">
            <img src="../../assets/tg_photo3.png" alt="">
          </el-col>
          <el-col :span="12"  :xs="{span: 24}">
            <div class="text">
              <h3>小巧便携、采用ABS环保材质</h3>
              <p>26 X 26 X 9 mm的迷你机身，让随手测细节精致，轻盈小巧，品 质可行，安全环保</p>
              <p>*ROHS测试报告编号：ED190826033C</p>
              <p>测试机构：东莞市信测科技有限公司</p>
            </div>
          </el-col>
        </el-row>
        <el-row class="section5" :gutter="40">
          <el-col :span="12" :xs="{span: 24}">
            <img src="../../assets/tg_photo4.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{span: 24}">
            <div class="plain">
              <p><span>产品型号</span><span>XW-Y01</span></p>
              <p><span>显示范围</span><span>34℃ - 42.2℃</span></p>
              <p><span>测量误差</span><span>± 0.3℃</span></p>
              <p><span>快速</span><span>测量时间小于1秒</span></p>
              <p><span>非接触</span><span>对准参照物测量，不接触表面</span></p>
              <p><span>测量距离</span><span>小于1cm</span></p>
              <p><span>产品尺寸</span><span>26*26*9mm</span></p>
              <p><span>产品重量</span><span>约7g</span></p>
              <p><span>包装尺寸</span><span>80*80*36mm</span></p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section1 {
  font-size: 38px;
  font-weight: normal;
  text-align: center;
  margin: 40px 0;
}
.section2,
.section3,
.section4,
.section5 {
  margin: 120px 0;

  .el-col {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: var(--margin-large);

    img {
      max-width: 100%;
    }
    .text {
      display: flex;
      justify-content: center;
      flex-direction: column;
      max-width: 400px;

      h3 {
        margin: 40px 0;
        text-align: center;
      }

      p {
        line-height: 1.66;
      }
    }
  }
}

.section2 {
  margin-top: 0;
}

.plain {
  p {
    padding: 0 24px;
    height: 50px;
    display: flex;
    align-items: center;
    
    span:first-child {
      display: inline-block;
      width: 4em;
      position: relative;
      text-align-last: justify;
      margin-right: 24px;
      &::after {
        content: ':';
        display: block;
        position: absolute;
        top: 0;
        right: -0.5em;
      }
    }
  }
  p:nth-child(2n + 1) {
    background-color: #ECECEC;
  }
}
</style>

